<div class="w-full flex flex-col flex-1 min-h-0">
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
              <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
                <i class="pi pi-calendar"></i>
              </span>
              Calendario de cobranza
            </h2>
            <p class="text-sm text-slate-500 mt-1">Resumen de cargos por fecha de vencimiento.</p>
          </div>
          <div class="flex flex-wrap items-center gap-2">
            <p-button
              icon="pi pi-chevron-left"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (onClick)="previousMonth()"
              pTooltip="Mes anterior"
              tooltipPosition="top" />
            <span class="min-w-[11rem] text-center text-base font-semibold text-slate-900 capitalize">{{ monthTitle() }}</span>
            <p-button
              icon="pi pi-chevron-right"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (onClick)="nextMonth()"
              pTooltip="Mes siguiente"
              tooltipPosition="top" />
            <p-button label="Hoy" severity="secondary" (onClick)="goToCurrentMonth()" />
          </div>
        </div>
        <div class="mt-4 flex flex-wrap gap-4 text-sm text-slate-600">
          <span><span class="font-semibold text-slate-900">{{ kpis().chargeCount }}</span> cargos en el mes</span>
          <span>Total: <span class="font-semibold text-slate-900">{{ kpis().totalAmount | currency:'MXN':'symbol':'1.2-2' }}</span></span>
        </div>
      </div>

      @if (error() && !loading()) {
        <div class="m-6 bg-red-50 border border-red-200 rounded-lg p-4">
          <p class="text-red-800">{{ error() }}</p>
          <p-button class="mt-3" label="Reintentar" severity="danger" (onClick)="retryLoad()" />
        </div>
      }

      @if (loading()) {
        <div class="flex-1 min-h-0 p-3 grid grid-cols-7 gap-px">
          @for (cell of [1,2,3,4,5,6,7,8,9,10,11,12,13,14]; track cell) {
            <div class="rounded-md border border-slate-100 p-1.5 min-h-[4.5rem]">
              <p-skeleton width="1.25rem" height="0.75rem" class="mb-1" />
              <p-skeleton width="100%" height="100%" />
            </div>
          }
        </div>
      } @else if (!error()) {
        <div class="flex-1 min-h-0 overflow-auto p-3">
          <div class="grid grid-cols-7 gap-px bg-slate-200 rounded-xl overflow-hidden border border-slate-200">
            @for (label of weekdayLabels; track label) {
              <div class="bg-slate-50 px-1.5 py-1.5 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                {{ label }}
              </div>
            }
            @for (day of days(); track day.key) {
              <button
                type="button"
                class="group relative bg-white min-h-[4.75rem] h-full p-0 flex text-left transition-colors"
                [class.bg-slate-50]="!day.inMonth"
                [class.cursor-pointer]="day.chargeCount > 0"
                [class.cursor-default]="day.chargeCount === 0"
                [disabled]="day.chargeCount === 0"
                (click)="openDaySummary(day)">
                @if (day.chargeCount > 0) {
                  <div
                    class="m-[3px] flex min-h-[4.5rem] h-[calc(100%-6px)] w-[calc(100%-6px)] flex-col rounded-lg border px-1.5 py-1 transition-all duration-150"
                    [ngClass]="day.isToday
                      ? 'border-sky-300 bg-gradient-to-b from-sky-100 to-sky-50 shadow-sm group-hover:from-sky-200/80 group-hover:to-sky-100 group-hover:shadow'
                      : day.inMonth
                        ? 'border-emerald-100 bg-gradient-to-b from-emerald-50 to-white group-hover:border-emerald-200 group-hover:from-emerald-100/90 group-hover:to-emerald-50 group-hover:shadow-sm'
                        : 'border-slate-200 bg-slate-50/80 group-hover:bg-slate-100'">
                    <span
                      class="inline-flex h-5 min-w-5 items-center justify-center self-start rounded-full px-1 text-[10px] font-bold leading-none"
                      [ngClass]="day.isToday
                        ? 'bg-sky-600 text-white'
                        : day.inMonth
                          ? 'bg-white/80 text-slate-700 ring-1 ring-emerald-100'
                          : 'bg-slate-200/70 text-slate-500'">
                      {{ day.date.getDate() }}
                    </span>
                    <div class="flex flex-1 min-h-0 flex-col items-center justify-center text-center gap-0.5 px-0.5">
                      <p
                        class="text-xs sm:text-sm font-bold tabular-nums tracking-tight leading-none truncate max-w-full"
                        [class.text-sky-900]="day.isToday"
                        [class.text-emerald-900]="!day.isToday && day.inMonth"
                        [class.text-slate-600]="!day.inMonth">
                        {{ day.totalAmount | currency:'MXN':'symbol':'1.0-0' }}
                      </p>
                      <span
                        class="inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-medium leading-none"
                        [ngClass]="day.isToday
                          ? 'bg-white/80 text-sky-800'
                          : day.inMonth
                            ? 'bg-white/80 text-emerald-800'
                            : 'bg-white/60 text-slate-500'">
                        <i class="pi pi-wallet text-[9px]"></i>
                        {{ day.chargeCount }} {{ day.chargeCount === 1 ? 'pago' : 'pagos' }}
                      </span>
                    </div>
                  </div>
                } @else {
                  <span
                    class="m-1 inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-[10px] font-bold leading-none"
                    [ngClass]="day.isToday
                      ? 'bg-sky-600 text-white shadow-sm'
                      : day.inMonth
                        ? 'text-slate-600'
                        : 'text-slate-400'">
                    {{ day.date.getDate() }}
                  </span>
                }
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <p-drawer
    [visible]="isDayDrawerOpen()"
    position="right"
    (visibleChange)="onDayDrawerVisibleChange($event)"
    styleClass="!w-[900px] !max-w-[100vw]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full pb-3 pr-2 border-b border-slate-200">
        <div>
          <h3 class="text-lg font-semibold text-slate-900 capitalize">{{ selectedDayTitle() }}</h3>
          @if (selectedDay(); as day) {
            <p class="text-sm text-slate-500 mt-0.5">
              {{ day.chargeCount }} {{ day.chargeCount === 1 ? 'cargo' : 'cargos' }}
              · {{ day.totalAmount | currency:'MXN':'symbol':'1.2-2' }}
            </p>
          }
        </div>
      </div>
    </ng-template>
    <div class="flex flex-col min-h-0 h-full">
      <p-table
        [value]="dayCharges()"
        dataKey="id"
        [lazy]="true"
        [paginator]="true"
        [rows]="dayPageSize()"
        [first]="dayPage() * dayPageSize()"
        [totalRecords]="dayTotalItems()"
        [rowsPerPageOptions]="pageSizeOptions"
        [loading]="dayChargesLoading()"
        [rowHover]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} cargos"
        (onLazyLoad)="onDayLazyLoad($event)"
        styleClass="day-charges-table p-datatable-striped p-datatable-sm"
        paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !justify-end">
        <ng-template pTemplate="header">
          <tr>
            <th class="!px-2">Cargo</th>
            <th class="!px-2">Cliente</th>
            <th class="!px-2">Estado</th>
            <th class="!px-2 hidden sm:table-cell">Método</th>
            <th class="!px-2 !text-right">Monto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-charge>
          <tr class="cursor-pointer hover:!bg-sky-50/50" (click)="openChargeDetails(charge)">
            <td class="!px-2 !py-2">
              <div class="flex items-center gap-2">
                <div [class]="getStatusIconClasses(charge.status)" class="[&>i]:text-sm">
                  <i [class]="getStatusIcon(charge.status)"></i>
                </div>
                <div class="min-w-0">
                  <div class="text-sm font-medium text-slate-900 truncate">
                    @if (getChargeSale(charge); as sale) {
                      {{ sale.number ?? charge.saleId ?? '—' }}
                    } @else if (getChargeInvoice(charge); as invoice) {
                      {{ invoice.series ?? '' }}{{ invoice.number ?? '' }}
                    } @else {
                      <span class="text-slate-500">—</span>
                    }
                  </div>
                  @if (charge.paymentNumber != null && charge.numberOfPayments != null) {
                    <div class="text-xs text-slate-500">Pago {{ charge.paymentNumber }} / {{ charge.numberOfPayments }}</div>
                  }
                </div>
              </div>
            </td>
            <td class="!px-2 !py-2">
              @let chargeCustomer = getChargeCustomer(charge);
              @if (chargeCustomer) {
                <div class="text-sm font-medium text-slate-900">{{ chargeCustomer.legalName ?? '-' }}</div>
                <div class="text-xs text-slate-500">{{ chargeCustomer.comercialName ?? '-' }}</div>
              } @else {
                <div class="text-sm text-slate-500">Cliente ID: {{ charge.customerId ?? '-' }}</div>
              }
            </td>
            <td class="!px-2 !py-2 whitespace-nowrap">
              <p-tag class="!text-xs" [value]="getStatusLabel(charge.status)" [severity]="getStatusSeverity(charge.status) ?? undefined" />
            </td>
            <td class="!px-2 !py-2 hidden sm:table-cell text-sm text-slate-600 whitespace-nowrap">
              {{ getCollectionMethodLabel(charge.collectionMethod) }}
            </td>
            <td class="!px-2 !py-2 text-sm font-medium text-slate-900 whitespace-nowrap !text-right">
              {{ (charge.total ?? 0) | currency:'MXN':'symbol':'1.2-2' }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="!px-2 !py-12 !text-center !text-slate-500">
              No hay cargos para este día.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-drawer>

  <app-charge-read
    [charge]="selectedCharge()"
    [visible]="isDetailsOpen()"
    (visibleChange)="onChargeDrawerVisibleChange($event)" />
</div>
